export function SectionLabel({ text, subtitle }) {
  return (
    <div className="mb-6 text-center">
      <p className="text-xs tracking-[0.3em] uppercase mb-1" style={{ color: 'var(--theme-text-secondary, rgba(180,140,70,0.6))', fontFamily: "'Times New Roman', serif" }}>{text}</p>
      {subtitle && <p className="text-[11px] italic" style={{ color: 'var(--theme-text-muted, rgba(180,140,70,0.45))', fontFamily: "'Times New Roman', serif" }}>{subtitle}</p>}
    </div>
  );
}
